import 'phaser'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { assert } from '../lib/assert-sidecar'
import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { IFontData } from './fontData'
import { fontData } from './fontData-sidecar'

export interface IStevieText extends IEntity {
  images: Phaser.GameObjects.Image[]
  visibleImages: number
  text: string
  font: IFontData
  x: number
  y: number
  layer: Phaser.GameObjects.Container
  tint: number
  monospace: boolean
  isVisible: boolean
}

const objs: IStevieText[] = []

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function create(
  font: IFontData,
  x: number,
  y: number,
  layer: Phaser.GameObjects.Container | null = null,
): IStevieText {
  let id = common.createId()

  if (!layer) {
    layer = layers.getLayers().ui
  }

  let obj: IStevieText = {
    eType: 'stevie-text',
    id,
    images: [],
    visibleImages: 0,
    isDead: false,
    text: '',
    font,
    x,
    y,
    layer,
    tint: 0xffffffff,
    monospace: false,
    isVisible: true,
  }
  objs.push(obj)
  return obj
}

export function moveTo(obj: IStevieText, x: number, y: number) {
  let dx = x - obj.x
  let dy = y - obj.y
  obj.x = x
  obj.y = y
  l.forEach(obj.images, (c) => {
    c.x += dx
    c.y += dy
  })
}

export function setText(
  obj: IStevieText,
  text: string,
  force: boolean = false,
) {
  if (text === obj.text && !force) {
    return
  }
  obj.text = text

  let x = obj.x
  let y = obj.y

  let font = obj.font
  // Make existing images invisible
  for (let i = 0; i < obj.images.length; i++) {
    let c = obj.images[i]
    c.visible = false
  }

  let fMonospace = fontData.getFrame(font, '0')
  assert.notNil(fMonospace)

  let imageIdx = 0
  for (let i = 0; i < text.length; i++) {
    // console.log('merp', i, text)
    let letter = text[i]
    if (letter === ' ') {
      if (obj.monospace) {
        x += fMonospace.width + font.widthAdjust
      } else {
        x += font.spaceWidth
      }
    } else {
      let f = fontData.getFrame(font, letter)
      if (f) {
        let tx = x
        if (obj.monospace) {
          tx += fMonospace.width - f.width
        }

        if (imageIdx >= obj.images.length) {
          let image = textCreateImageFromFrame(obj.layer, f, tx, y)
          image.tint = obj.tint
          obj.images.push(image)
        } else {
          obj.images[imageIdx].x = tx
          obj.images[imageIdx].y = y
          obj.images[imageIdx].frame = f
        }
        obj.images[imageIdx].visible = obj.isVisible

        if (obj.monospace) {
          f = fMonospace
        }

        x += f.width + font.widthAdjust

        imageIdx++
      } else {
        x += font.spaceWidth
        console.warn('missing font letter', letter)
      }
    }
  }
  obj.visibleImages = imageIdx
}

export function kill(obj: IStevieText) {
  obj.isDead = true
}

export function updateAll() {
  objs.forEach((c) => {
    // update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.images.forEach((d) => {
      d.destroy()
    })
  })
}

export function textCreateImageFromFrame(
  layer: Phaser.GameObjects.Container,
  frame: Phaser.Textures.Frame,
  x: number,
  y: number,
  scale: number = 1,
) {
  let scene = common.getPhaserScene()
  let image = scene.add.image(0, 0, '')
  layer.add(image)
  image.width = frame.width
  image.height = frame.height
  image.frame = frame
  image.originX = 0.5
  image.originY = 0.5
  image.x = x
  image.y = y
  if (scale) {
    image.setScale(scale)
  }
  image.setDisplayOrigin(0, 0)

  return image
}

export function setVisible(obj: IStevieText, visible: boolean) {
  obj.isVisible = visible
  for (let i = 0; i < obj.images.length; i++) {
    let c = obj.images[i]
    c.visible = visible && i < obj.visibleImages
  }
}

export function setTint(obj: IStevieText, tint: number) {
  obj.tint = tint
  for (let i = 0; i < obj.images.length; i++) {
    let c = obj.images[i]
    c.tint = tint
  }
}

export function setBulkVisible(objs: IStevieText[], isVisible: boolean) {
  l.forEach(objs, (c) => setVisible(c, isVisible))
}

export function setMonospace(obj: IStevieText, monospace: boolean) {
  obj.monospace = monospace
  setText(obj, obj.text, true)
}
